
import AlertsList from '../components/AlertsList';

const Alerts = () => {
    return (
        <AlertsList />
    );
}

export default Alerts;